import styled from 'styled-components';

export const Container = styled.div`
    max-width: 500px;
    margin: 80px auto 1rem;
    h1{
      margin-bottom: 24px;
    }
`;

export const Card = styled.form`
    border-radius: 6px;
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 30%);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 24px 16px;
    min-height: 214px;
    min-width: 100%;

    button{
      margin-top: 24px;
    }
`;

export const Spacer = styled.div`
      margin-top: 16px;
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.gray.athens};
  border-radius: 4px;
  height: 4px;
  width: 100%;
  margin: 24px 0;
`;

export const Footer = styled.footer`
  align-items: center;
  display: flex;
  font-size: 1rem;
  justify-content: space-around;
  width: 100%;

  li{
    color: ${({ theme }) => theme.colors.gray.oslo};
  }

  a{
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: none;
  }
`;

export const SubmitArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span{
    margin-top: 16px;
    color: ${({ theme }) => theme.colors.error};
    text-align: center;
  }
`;
